import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { ThemeProvider as MuiThemeProvider, CssBaseline } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ThemeProvider, useTheme } from "@/contexts/ThemeContext";
import { AuthProvider } from "@/contexts/AuthContext";
import { buildTheme } from "@/theme";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import Search from "@/pages/Search";
import VillaDetail from "@/pages/VillaDetail";
import Booking from "@/pages/Booking";
import Dashboard from "@/pages/Dashboard";
import Login from "@/pages/Login";
import MapPage from "@/pages/MapPage";
import OwnerPortal from "@/pages/OwnerPortal";
import AdminPortal from "@/pages/AdminPortal";
import StaticPage from "@/pages/StaticPage";

function MuiThemeBridge({ children }) {
  const { theme } = useTheme();
  return <MuiThemeProvider theme={buildTheme(theme)}>{children}</MuiThemeProvider>;
}

function App() {
  return (
    <ThemeProvider>
      <MuiThemeBridge>
        <CssBaseline />
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <AuthProvider>
            <BrowserRouter>
              <Layout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/villas" element={<Search />} />
                  <Route path="/villas/:id" element={<VillaDetail />} />
                  <Route path="/booking/:id" element={<Booking />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Navigate to="/login" replace />} />
                  <Route path="/map" element={<MapPage />} />
                  <Route path="/owner" element={<OwnerPortal />} />
                  <Route path="/admin" element={<AdminPortal />} />
                  <Route path="/p/:slug" element={<StaticPage />} />
                </Routes>
              </Layout>
              <Toaster position="bottom-right" toastOptions={{ style: { fontFamily: "Outfit, sans-serif" } }} />
            </BrowserRouter>
          </AuthProvider>
        </LocalizationProvider>
      </MuiThemeBridge>
    </ThemeProvider>
  );
}

export default App;
